import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PaginationParams, SortingParams } from '../../hardware-certificates.interface';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'cloud-business-management-requests-report-qes-table',
  templateUrl: './business-management-requests-report-qes-table.component.html',
  styleUrls: ['./business-management-requests-report-qes-table.component.scss']
})
export class BusinessManagementRequestsReportQesTableComponent implements OnInit {
  @Input() managementRequests: any[] = [];
  @Input() totalCount: number = 0;
  @Input() pageSize: number = 10;
  @Input() pageIndex: number = 0;
  @Input() activeSort: string = '';
  @Input() sortDirection: 'asc' | 'desc' | '' = '';

  @Output() pageChange = new EventEmitter<PaginationParams>();
  @Output() sortChange = new EventEmitter<{ active: string, direction: 'asc' | 'desc' | '' }>();

  displayedColumns: string[] = ['request_number', 'action', 'created_on', 'certificateHolderName', 'status', 'requestCreatorFullName'];
  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.dataSource.data = this.managementRequests || [];
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageIndex = this.pageIndex;
      this.paginator.pageSize = this.pageSize;
      this.paginator.length = this.totalCount;
      this.paginator.page.subscribe((pageEvent: PageEvent) => {
        this.onPageChange(pageEvent);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['managementRequests']) {
      this.dataSource.data = this.managementRequests || [];
    }
    if (this.paginator) {
      if (changes['totalCount']) {
        this.paginator.length = this.totalCount;
      }

      if (changes['pageIndex']) {
        this.paginator.pageIndex = this.pageIndex;
      }

      if (changes['pageSize']) {
        this.paginator.pageSize = this.pageSize;
      }
    }
    if (this.sort) {
      if (changes['activeSort']) {
        this.sort.active = this.activeSort;
      }

      if (changes['sortDirection']) {
        this.sort.direction = this.sortDirection as 'asc' | 'desc';
      }
    }
  }

  onSortChange(event: Sort) {
    this.sortChange.emit(event);
  }

  onPageChange(event: PageEvent) {
    this.pageChange.emit({
      pageIndex: event.pageIndex,
      pageSize: event.pageSize
    });
  }
  mapCertificateStatus(status: string) {
    switch (status) {
      case "NEW":
        return this.translateService.instant('certificates.certificateStatus.inProgress');
      case "SIGNED_BY_AGENT":
        return this.translateService.instant('certificates.certificateStatus.signedByAgent');
      case "COMPLETED":
        return this.translateService.instant('certificates.certificateStatus.completed');
      case "ERROR":
        return this.translateService.instant('certificates.certificateStatus.error');
    }
  }

  mapCertificateAction(status: string) {
    switch (status) {
      case "HOLD":
        return this.translateService.instant('certificates.certificateStatus.holded');
      case "RESTORE":
        return this.translateService.instant('certificates.certificateStatus.restore');
      case "REVOKE":
        return this.translateService.instant('certificates.revoke');
    }
  }

  mapCertificateExecutedAction(status: string) {
    switch (status) {
      case "HOLD":
        return this.translateService.instant('certificates.certificateExecutedAction.hold');
      case "RESTORE":
        return this.translateService.instant('certificates.certificateExecutedAction.restore');
      case "REVOKE":
        return this.translateService.instant('certificates.certificateExecutedAction.revoke');
    }
  }
}
